export default __webpack_public_path__ + "static/media/fishery.4c5eee11.svg";